import { useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import axios from "axios";
import States from "../../utils/state.json";
import { ServerPath } from "../../Constant";
// import { uploadImage } from "../../Services/azure-storage-blob";
import UploadDrive from "../../assets//images/svg/DriveImg.svg";
import AadharUpload from "../../assets//images/svg/AadharImg.svg";
import filter from "../../assets//images/svg/Filter.svg";
import greenEye from "../../assets/images/svg/eyegreen.svg";
import {uploadImage} from '../../Services/r2-storage-blob.js';
import { _axios } from "../../utils/axios.jsx";

// Convert ISO date (e.g., '2024-07-31T18:30:00.000Z') to 'YYYY-MM-DD'
const extractDateFromISO = (isoString) => {
  return isoString?.split("T")[0]; // Extract the date part (YYYY-MM-DD)
};

const DetailInfoAdmin = (props) => {
  // For Aadhar card front
  const [imageAadharPreview, setImageAadharPreview] = useState(
    props?.data?.aadhar_Front_Url ?? null
  );
  const [selectedAadharFile, setAadharSelectedFile] = useState(null);
  const [uploadAadharStatus, setUploadAadharStatus] = useState("");
  const [aadharFrontUrl, setAadharFrontUrl] = useState("");
  const [documentType, setDocumentType] = useState("");
  const [isDetailedInfo, setIsDetailedInfo] = useState(false);

  const handleImageChangeAadhar = async (e) => {
    if (drivingLicenseUrl) {
      setError("Please remove driving license first to upload Aadhar card");
      e.target.value = null;
      return;
    }
    const file = e.target.files[0];
    if (file) {
      // Set selected file info
      setAadharSelectedFile(file);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {};
      reader.readAsDataURL(file);

      // Upload to Azure Blob Storage
      try {
        const filename = `web_Aadharimage_${Date.now()}`;
        const container = "web-Aadharapp";
        const subcontainer = "Aadhar-images";

        // setUploadAadharStatus("Uploading...");

        const url = await uploadImage(file, filename, container, subcontainer);
        console.log("This is my url ", url);
        setImageAadharPreview(url);
        setAadharFrontUrl(url);
        setUploadAadharStatus("Upload successful!");
      } catch (error) {
        console.error("Error uploading image:", error);
        setUploadAadharStatus("Upload failed. Please try again.");
      }
    }
  };

  // For Aadhar Back
  const [imageAadharBackPreview, setImageAadharBackPreview] = useState(
    props?.data?.aadhar_Back_Url ?? null
  );
  const [selectedAadharBackFile, setAadharBackSelectedFile] = useState(null);
  const [uploadAadharBackStatus, setUploadAadharBackStatus] = useState("");
  const [aadharBackUrl, setAadharBackUrl] = useState("");

  const handleImageChangeAadharBack = async (e) => {
    if (drivingLicenseUrl) {
      setError("Please remove driving license first to upload Aadhar card");
      e.target.value = null;
      return;
    }
    const file = e.target.files[0];
    if (file) {
      // Set selected file info
      setAadharBackSelectedFile(file);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {};
      reader.readAsDataURL(file);

      // Upload to Azure Blob Storage
      try {
        const filename = `web_Aadharimage_${Date.now()}`;
        const container = "web-Aadharapp";
        const subcontainer = "Aadhar-images";

        setUploadAadharBackStatus("Uploading...");

        const url = await uploadImage(file, filename, container, subcontainer);
        console.log("This is my url", url);
        setImageAadharBackPreview(url);
        setAadharBackUrl(url);
        setUploadAadharBackStatus("Upload successful!");
      } catch (error) {
        console.error("Error uploading image:", error);

        setUploadAadharBackStatus("Upload failed. Please try again.");
      }
    }
  };

  // For Driving License
  const [imagePreview, setImagePreview] = useState(
    props?.data?.driving_license_url ?? null
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const [drivingLicenseUrl, setDrivingLicenseUrl] = useState("");

  const handleImageChange = async (e) => {
    if (aadharFrontUrl || aadharBackUrl) {
      setError(
        "Please remove Aadhar card images first to upload driving license"
      );
      e.target.value = null;
      return;
    }
    const file = e.target.files[0];
    if (file) {
      // Set selected file info
      setSelectedFile(file);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {};
      reader.readAsDataURL(file);

      // Upload to Azure Blob Storage
      try {
        const filename = `web_image_${Date.now()}`;
        const container = "web-app";
        const subcontainer = "images";

        setUploadStatus("Uploading...");

        const url = await uploadImage(file, filename, container, subcontainer);
        console.log("This is my url driving ", url);
        setImagePreview(url);
        setDrivingLicenseUrl(url);
        setUploadStatus("Upload successful!");
      } catch (error) {
        console.error("Error uploading image:", error);
        setUploadStatus("Upload failed. Please try again.");
      }
    }
  };

  useEffect(() => {
    if (props?.data) {
      // Check if Aadhar URLs exist
      if (props.data.aadhar_Front_Url || props.data.aadhar_Back_Url) {
        setDocumentType("aadhar");
        // Set the preview states for Aadhar
        setImageAadharPreview(props.data.aadhar_Front_Url);
        setImageAadharBackPreview(props.data.aadhar_Back_Url);
        setAadharFrontUrl(props.data.aadhar_Front_Url);
        setAadharBackUrl(props.data.aadhar_Back_Url);
      }
      // Check if driving license URL exists
      else if (props.data.driving_license_url) {
        setDocumentType("driving");
        // Set the preview state for driving license
        setImagePreview(props.data.driving_license_url);
        setDrivingLicenseUrl(props.data.driving_license_url);
      }
    }
  }, [props.data]);

  const handleDocumentTypeChange = (e) => {
    const newType = e.target.value;
    setDocumentType(newType);

    // Clear existing uploads when switching document type
    if (newType === "aadhar") {
      setImagePreview(null);
      setDrivingLicenseUrl("");
      setSelectedFile(null);
    } else if (newType === "driving") {
      setImageAadharPreview(null);
      setImageAadharBackPreview(null);
      setAadharFrontUrl("");
      setAadharBackUrl("");
      setAadharSelectedFile(null);
      setAadharBackSelectedFile(null);
    }

    setError(""); // Clear any existing errors
  };

  const [showUserID, setShowUserID] = useState(false);

  const [showEmail, setShowEmail] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const maskUserID = (id) => {
    if (id.length <= 4) return id;
    return showUserID ? id : id.replace(/.(?=.{4})/g, "*");
  };

  const toggleEmailVisibility = () => {
    setShowEmail(!showEmail);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  console.log("user Details", props?.data);
  const [show, setShow] = useState(false);
  const [userName, setUserName] = useState(props?.data?.user_name ?? "");
  // const [userIdDeclare, setUserIDDeclare] = useState(
  //   props?.data?.user_id ?? ""
  // );
  const [userIdDeclare, setUserIDDeclare] = useState("");
  console.log("this is users", userIdDeclare);
  const [passDeclare, setPassDeclare] = useState(props?.data?.password ?? "");
  // console.log("this is pass22", passDeclare);
  const [userMiddleName, setUserMiddleName] = useState(
    props?.data?.middle_name ?? ""
  );
  const [userLastName, setUserLastName] = useState(
    props?.data?.last_name ?? ""
  );
  // const [userPhoneNumber, setUserPhoneNumber] = useState(
  //   props?.data?.mobile ?? ""
  // );
  const [userAltPhoneNumber, setUserAltPhoneNumber] = useState(
    props?.data?.alt_phone_number ?? ""
  );
  console.log("altPhone is coming here" + userAltPhoneNumber);

  const [userEmail, setUserEmail] = useState(props?.data?.email ?? "");
  console.log("Email id is coming here" + userEmail);

  console.log("Raw props data:", props.data);
  console.log("Email value from props:", props.data?.email);

  const [country, setCountry] = useState(props?.data?.country ?? "India");
  const [selectedStateDistrict, setSelectedStateDistrict] = useState([]);
  const [state, setState] = useState(() => {
    const selectedState = States.find(
      (item) => item.state === props?.data?.state
    );
    setSelectedStateDistrict(selectedState?.districts ?? []);
    return props?.data?.state ?? 0;
  });
  const [district, setDistrict] = useState(props?.data?.district ?? 0);
  const [city, setCity] = useState(props?.data?.city ?? "");
  const [pinCode, setPinCode] = useState(props?.data?.pin_code ?? "");
  const [address, setAddress] = useState(props?.data?.address ?? "");
  // const [email, setEmail] = useState('');

  const [mobile, setMobile] = useState(props?.data?.mobile ?? "");
  // const [password, setPassword] = useState('');
  const [dob, setDob] = useState(
    extractDateFromISO(props?.data?.dob ?? props?.data?.dateofbirth ?? "")
  );
  const [bloodGroup, setBloodGroup] = useState(props?.data?.bloodgroup ?? null);

  const [userSignedUpAsHost, setUserSignedUpAsHost] = useState(
    props?.data?.user_signed_up_as_host ?? ""
  );
  const [userSignedUpAsVolunteer, setUserSignedUpAsVolunteer] = useState(
    props?.data?.user_signed_up_as_volunteer ?? ""
  );
  const [userImage, setUserImage] = useState("");
  const [userLogData, setUserLogData] = useState();
  const [uploading, setUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const handleShow = () => {
    setShow(true);
    setIsDetailedInfo(false);
  };

  // Add handler for when detailed info is shown
  const showDetailedInfo = () => {
    setIsDetailedInfo(true);
  };

  const getModalTitle = () => {
    return "Detailed Info";
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const body = {
          user_id: props?.data?.user_id,
        };
        const response = await _axios.post(
          `${ServerPath}/map/user-coordinates`,
          body
        );
        console.log("user Coordinates", response.data);
        const actualData = response?.data?.data;
        if (response?.data?.data.length > 0) setUserLogData(actualData[0]);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchData();
  }, []);

  const exceedsBy7Days = (dateString) => {
    // Parse the given date
    const givenDate = new Date(dateString);
    // Get the current date
    const today = new Date();

    // Normalize both dates to midnight in local time
    const sevenDaysFromNow = new Date(givenDate); // Clone today's date
    sevenDaysFromNow.setDate(givenDate.getDate() + 7); // Add 7 days

    // Compare the dates
    return today > sevenDaysFromNow; // Returns true if the given date exceeds by more than 7 days
  };

  const handleFileChange = (e) => {
    setUserImage(e.target.files[0]);
  };

  const calculateAge = (dobString) => {
    // Return empty string if no date is selected
    if (!dobString) return "";

    const dob = new Date(dobString); // Parse the date of birth
    if (isNaN(dob.getTime())) return "";
    const today = new Date(); // Get the current date

    // Return empty string if future date is selected
    if (dob > today) return "";

    let age = today.getFullYear() - dob.getFullYear(); // Initial age calculation based on year difference
    const monthDifference = today.getMonth() - dob.getMonth();
    const dayDifference = today.getDate() - dob.getDate();

    // Adjust the age if the current month/day is before the birth month/day
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age.toString();
  };
  // Get today's date in YYYY-MM-DD format for max attribute
  const today = new Date().toISOString().split("T")[0];

  // functionality for clicking the "Add More" button generates a new row

  const [contacts, setContacts] = useState(
    props?.data?.emergency_contact_name_two?.length > 1 &&
      props?.data?.emergency_contact_name_three?.length > 1
      ? [
          {
            name: props?.data?.emergency_contact_name ?? "",
            relation: props?.data?.relationship ?? null,
            number: props?.data?.emergency_contact_mobile ?? "",
            alternateNumber: props?.data?.emergency_contact_mobile_alt ?? "",
          },
          {
            name: props?.data?.emergency_contact_name_two ?? "",
            relation: props?.data?.relationship_two ?? null,
            number: props?.data?.emergency_contact_mobile_two ?? "",
            alternateNumber:
              props?.data?.emergency_contact_mobile_two_alt ?? "",
          },
          {
            name: props?.data?.emergency_contact_name_three ?? "",
            relation: props?.data?.relationship_three ?? null,
            number: props?.data?.emergency_contact_mobile_three ?? "",
            alternateNumber:
              props?.data?.emergency_contact_mobile_three_alt ?? "",
          },
        ]
      : props?.data?.emergency_contact_name_two?.length > 1
      ? [
          {
            name: props?.data?.emergency_contact_name ?? "",
            relation: props?.data?.relationship ?? null,
            number: props?.data?.emergency_contact_mobile ?? "",
            alternateNumber: props?.data?.emergency_contact_mobile_alt ?? "",
          },
          {
            name: props?.data?.emergency_contact_name_two ?? "",
            relation: props?.data?.relationship_two ?? null,
            number: props?.data?.emergency_contact_mobile_two ?? "",
            alternateNumber:
              props?.data?.emergency_contact_mobile_two_alt ?? "",
          },
        ]
      : [
          {
            name: props?.data?.emergency_contact_name ?? "",
            relation: props?.data?.relationship ?? null,
            number: props?.data?.emergency_contact_mobile ?? "",
            alternateNumber: props?.data?.emergency_contact_mobile_alt ?? "",
          },
        ]
  );

  const handleContactChange = (index, field, value) => {
    setContacts((prevContacts) => {
      const newContacts = [...prevContacts];
      newContacts[index] = {
        ...newContacts[index],
        [field]: value,
      };
      return newContacts;
    });
  };

  const handleAddMore = () => {
    if (contacts.length < 3) {
      setContacts([
        ...contacts,
        {
          name: "",
          relation: null,
          number: "",
          alternateNumber: "",
        },
      ]);
    }
  };

  const handleRemoveContact = (index) => {
    setContacts(contacts.filter((_, i) => i !== index));
  };

  // ------------------------------------------------------------------------------------------

  const handleSubmit = async (event) => {
    event.preventDefault();
    setUploading(true);

    // if (props?.isAddUser && !drivingLicenseUrl) {
    //   setUploadStatus(false);
    //   setError("Please upload your driving license before submitting.");
    //   return;
    // }
    if (
      userName.length < 1 ||
      userLastName.length < 1 ||
      userEmail.length < 1 ||
      state.length < 2 ||
      district.length < 2 ||
      city.length < 1 ||
      pinCode.length < 6 ||
      address.length < 0 ||
      dob.length < 0 ||
      bloodGroup.length < 0
    ) {
      setUploading(false);
      setError("Please fill in all Personal Details fields before submitting.");
      return; // Stop the submission if there are empty fields
    }
    // if (
    //   emergencyContactName?.length < 1 ||
    //   emergencyContactRelation?.length < 2 ||
    //   emergencyContactNumber?.length < 10
    // ) {
    //   setUploading(false);
    //   setError(
    //     "Please fill in all Emergency Details fields before submitting."
    //   );
    //   return; // Stop the submission if there are empty fields
    // }

    // if (
    //   secondEmergencyContactName?.length > 0 &&
    //   (secondEmergencyContactRelation?.length < 2 ||
    //     secondEmergencyContactNumber?.length < 10)
    // ) {
    //   setUploading(false);
    //   setError(
    //     "Please fill in all Emergency Details fields before submitting."
    //   );
    //   return; // Stop the submission if there are empty fields
    // }

    // if (
    //   thirdEmergencyContactName?.length > 0 &&
    //   (thirdEmergencyContactRelation?.length < 2 ||
    //     thirdEmergencyContactNumber?.length < 10)
    // ) {
    //   setUploading(false);
    //   setError(
    //     "Please fill in all Emergency Details fields before submitting."
    //   );
    //   return; // Stop the submission if there are empty fields
    // }

    // if (props?.isAddUser && mobile.length < 10) {
    //   setUploading(false);
    //   setError("Please enter 10 digit mobile number fields before submitting.");
    //   return; // Stop the submission if there are empty fields
    // }

    // Validate emergency contacts
    if (contacts.length > 0) {
      for (let i = 0; i < contacts.length; i++) {
        const contact = contacts[i];
        if (
          contact.name?.length < 1 ||
          contact.relation?.length < 2 ||
          contact.number?.length < 10
        ) {
          setUploading(false);
          setError(
            `Please fill in all Emergency Contact ${
              i + 1
            } fields before submitting.`
          );
          return; // Stop the submission if there are empty fields
        }
      }
    }

    // --------- Document validation - either Aadhar (both sides) OR driving license required-------------------------------------------------
    const hasAadhar = aadharFrontUrl && aadharBackUrl;
    const hasDrivingLicense = drivingLicenseUrl;

    if (!hasAadhar && !hasDrivingLicense) {
      setUploading(false);
      setError(
        "Please upload either Aadhar Card (both front and back) OR Driving License."
      );
      return;
    }

    if (hasAadhar && hasDrivingLicense) {
      setUploading(false);
      setError(
        "Please upload either Aadhar Card OR Driving License, not both."
      );
      return;
    }
    // --------------------------------------------------------------------------------------------------------------------------

    setError("");

    try {
      const createUser = {
        user_name: userName,
        middle_name: userMiddleName,
        last_name: userLastName,
        altPhoneNumber: userAltPhoneNumber,
        email: userEmail,
        country: country,
        state: state,
        district: district,
        city: city,
        pin_code: pinCode,
        address: address,
        dateofbirth: dob,
        bloodgroup: bloodGroup,
        mobile: mobile,
        // aadhar_Front_Url: aadharFrontUrl || props?.data?.aadhar_Front_Url || "",
        // aadhar_Back_Url: aadharBackUrl || props?.data?.aadhar_Back_Url || "",
        // driving_license_url:
        //   drivingLicenseUrl || props?.data?.driving_license_url || "",
        aadhar_Front_Url: hasAadhar ? aadharFrontUrl : "",
        aadhar_Back_Url: hasAadhar ? aadharBackUrl : "",
        driving_license_url: hasDrivingLicense ? drivingLicenseUrl : "",
        // emergency_contact_name: emergencyContactName,
        // relationship: emergencyContactRelation,
        // emergency_contact_mobile: emergencyContactNumber,
        // emergency_contact_mobile_alt: emergencyContactAlternateNumber,

        // emergency_contact_name_two: secondEmergencyContactName,
        // relationship_two: secondEmergencyContactRelation,
        // emergency_contact_mobile_two: secondEmergencyContactNumber,
        // emergency_contact_mobile_two_alt: secondEmergencyContactAlternateNumber,

        // emergency_contact_name_three: thirdEmergencyContactName,
        // relationship_three: thirdEmergencyContactRelation,
        // emergency_contact_mobile_three: thirdEmergencyContactNumber,
        // emergency_contact_mobile_three_alt:
        //   thirdEmergencyContactAlternateNumber,

        // First emergency contact
        emergency_contact_name: contacts[0]?.name || "",
        relationship: contacts[0]?.relation || "",
        emergency_contact_mobile: contacts[0]?.number || "",
        emergency_contact_mobile_alt: contacts[0]?.alternateNumber || "",

        // Second emergency contact
        emergency_contact_name_two: contacts[1]?.name || "",
        relationship_two: contacts[1]?.relation || "",
        emergency_contact_mobile_two: contacts[1]?.number || "",
        emergency_contact_mobile_two_alt: contacts[1]?.alternateNumber || "",

        // Third emergency contact
        emergency_contact_name_three: contacts[2]?.name || "",
        relationship_three: contacts[2]?.relation || "",
        emergency_contact_mobile_three: contacts[2]?.number || "",
        emergency_contact_mobile_three_alt: contacts[2]?.alternateNumber || "",

        user_signed_up_as_host: userSignedUpAsHost,
        user_signed_up_as_volunteer: userSignedUpAsVolunteer,
      };

      const updateUser = { ...createUser, user_id: props?.data?.user_id };

      const response = props.isAddUser
        ? await _axios.post(`${ServerPath}/web-users/admin-create`, createUser)
        : await _axios.patch(`${ServerPath}/web-users/update`, updateUser);

      console.log(response.data);

      handleClose();
      window.location.reload();
    } catch (error) {
      console.error(error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      {/* <img onClick={handleShow}
                style={{ cursor: "pointer" }}

                src={greenEye} alt="View" width="35" height="30" /> */}

      {props?.isEditButton ? (
        <img
          onClick={handleShow}
          style={{ cursor: "pointer" }}
          src={greenEye}
          alt="View"
          width="35"
          height="30"
        />
      ) : (
        <a
          onClick={handleShow}
          className="text-decoration-none float-end"
          style={{ cursor: "pointer" }}
        >
          {props?.data?.user_id}
        </a>
      )}

      {/* <a
          onClick={handleShow}
          className="text-decoration-none float-end"
          style={{ cursor: "pointer" }}
        >
          {props?.data?.user_id}
        </a> */}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title onClick={showDetailedInfo}>
            {getModalTitle()}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: "calc(100vh - 210px)",
            overflowY: "auto",
          }}
        >
          {error && <div className="alert alert-danger">{error}</div>}
          <Form onSubmit={handleSubmit}>
            <Row className="g-3">
              <h5 className="txt-primary">Personal Details</h5>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    First Name <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter first name"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Last Name <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter last name"
                    value={userLastName}
                    onChange={(e) => setUserLastName(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Select phone number"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    maxLength={10}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Alternate Phone Number
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Enter alternate phone number"
                    value={userAltPhoneNumber}
                    onChange={(e) => setUserAltPhoneNumber(e.target.value)}
                    maxLength={10}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Email <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="Email"
                    placeholder="Enter email"
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Country <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Country"
                    value={country}
                    disabled
                    onChange={(e) => setCountry(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    State <span style={{ color: "red" }}>*</span>
                  </Form.Label>

                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={0}
                    value={state}
                    disabled
                    onChange={(e) => {
                      if (state !== e.target.value) {
                        setDistrict(0);
                      }
                      const selectedState = States.find(
                        (item) => item.state === e.target.value
                      );
                      setSelectedStateDistrict(selectedState?.districts ?? []);
                      setState(e.target.value);
                    }}
                  >
                    <option disabled selected value={0}>
                      {"Select state"}
                    </option>
                    {States.map((item) => {
                      return <option value={item.state}>{item.state}</option>;
                    })}
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    District <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={0}
                    value={district}
                    disabled
                    onChange={(e) => setDistrict(e.target.value)}
                  >
                    <option disabled selected value={0}>
                      {"Select District"}
                    </option>
                    {selectedStateDistrict?.length > 0 &&
                      selectedStateDistrict.map((item) => {
                        return (
                          <option value={item.district}>{item.district}</option>
                        );
                      })}
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Town/City <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter town/city"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Pincode <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter pincode"
                    value={pinCode}
                    onChange={(e) => setPinCode(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Label>
                  Plot No, Street Address{" "}
                  <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <textarea
                  rows="3"
                  placeholder="Enter plot no, street address"
                  class="form-control form-control"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  disabled
                />
              </Col>
              <hr className="mt-4"></hr>
              <h5 className="txt-primary">Emergency Details</h5>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Blood Group <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <select
                    name="select"
                    class="form-control form-select form-select"
                    defaultValue={null}
                    value={bloodGroup}
                    disabled
                    onChange={(e) => setBloodGroup(e.target.value)}
                  >
                    <option selected disabled value={null}>
                      {"Select blood group"}
                    </option>
                    <option value="A+">{"A RhD positive (A+)"}</option>
                    <option value="A-">{"A RhD negative (A-)"}</option>
                    <option value="B+">{"B RhD positive (B+)"}</option>
                    <option value="B-">{"B RhD negative (B-)"}</option>
                    <option value="O+">{"O RhD positive (O+)"}</option>
                    <option value="O-">{"O RhD negative (O-)"}</option>
                    <option value="AB+">{"AB RhD positive (AB+)"}</option>
                    <option value="AB-">{"AB RhD negative (AB-)"}</option>
                  </select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="formGridUserName">
                  <Form.Label>
                    Date of Birth <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Enter DOB"
                    value={dob}
                    disabled
                    max={today} // Prevents selection of future dates
                    onChange={(e) => {
                      console.log("dob", e.target.value);
                      setDob(e.target.value);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group
                  controlId="formGridUserName"
                  className="input-group-solid"
                >
                  <Form.Label>
                    Age <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Age"
                    // value={calculateAge(dob) ?? 0}
                    value={calculateAge(dob)}
                    max={today} // Prevents selection of future dates
                    disabled
                  />
                </Form.Group>
              </Col>
              <Form.Label>
                Adhar Card Front & Back or Driving License or Voter ID
                attachment <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Col md={3} className="mt-0">
                <Form.Group controlId="formGridDocType">
                  <Form.Label>Document Type</Form.Label>
                  <select
                    name="documentType"
                    className="form-control form-select form-select"
                    value={documentType}
                    disabled
                    onChange={handleDocumentTypeChange}
                  >
                    <option value="">Select</option>
                    <option value="aadhar">Aadhar Card</option>
                    <option value="driving">Driving License</option>
                  </select>
                </Form.Group>
              </Col>

              {documentType === "aadhar" && (
                <>
                  <Col md={3} className="mt-0">
                    <Form.Group controlId="formGridAadhar">
                      <input
                        type="file"
                        id="file-upload-aadhar"
                        accept="image/*,.pdf"
                        onChange={handleImageChangeAadhar}
                        style={{ display: "none" }}
                      />
                      <label
                        htmlFor="file-upload-aadhar"
                        className="w-100 cursor-pointer"
                      >
                        {imageAadharPreview ? (
                          <img
                            className="w-100 p-3 border rounded-3"
                            src={imageAadharPreview}
                            alt="Upload file aadhar front side "
                            style={{ height: "163px", objectFit: "contain" }}
                          />
                        ) : (
                          <img
                            className="w-100 p-3 border rounded-3"
                            src={AadharUpload}
                            alt="Upload file aadhar front side "
                            style={{ height: "163px", objectFit: "contain" }}
                          />
                        )}
                      </label>
                    </Form.Group>
                  </Col>
                  <Col md={3} className="mt-0">
                    <Form.Group controlId="formGridAadharBack">
                      <input
                        type="file"
                        id="file-upload-aadhar-back"
                        accept="image/*,.pdf"
                        onChange={handleImageChangeAadharBack}
                        style={{ display: "none" }}
                      />
                      <label
                        htmlFor="file-upload-aadhar-back"
                        className="w-100 cursor-pointer"
                      >
                        {imageAadharBackPreview ? (
                          <img
                            className="w-100 p-3 border rounded-3"
                            src={imageAadharBackPreview}
                            alt="Upload file aadhar back side "
                            style={{ height: "163px", objectFit: "contain" }}
                          />
                        ) : (
                          <img
                            className="w-100 p-3 border rounded-3"
                            src={AadharUpload}
                            alt="Upload file aadhar back side "
                            style={{ height: "163px", objectFit: "contain" }}
                          />
                        )}
                      </label>
                    </Form.Group>
                  </Col>
                </>
              )}
              {documentType === "driving" && (
                <Col md={3} className="mt-0">
                  <Form.Group controlId="formGridDrivingLicense">
                    <input
                      type="file"
                      id="file-upload"
                      accept="image/*,.pdf"
                      onChange={handleImageChange}
                      style={{ display: "none" }}
                    />
                    <label
                      htmlFor="file-upload"
                      className="w-100 cursor-pointer"
                    >
                      {imagePreview ? (
                        <img
                          className="w-100 p-3 border rounded-3"
                          src={imagePreview}
                          alt="driving license preview"
                          style={{ height: "163px", objectFit: "contain" }}
                        />
                      ) : (
                        <img
                          className="w-100 p-3 border rounded-3"
                          src={UploadDrive}
                          alt="upload driving license"
                          style={{ height: "163px", objectFit: "contain" }}
                        />
                      )}
                    </label>
                  </Form.Group>
                </Col>
              )}

              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Emergency Contact Info</h6>
                {/* {contacts.length < 3 && (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleAddMore}
                                    >
                                        Add More
                                    </button>
                                )} */}
              </div>

              {contacts.map((contact, index) => (
                <div key={index} className="row mb-4 position-relative">
                  <Col md={3}>
                    <Form.Group controlId={`formGridUserName-${index}`}>
                      <Form.Label>
                        Full Name <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="First Name"
                        value={contact.name}
                        onChange={(e) =>
                          handleContactChange(index, "name", e.target.value)
                        }
                        disabled
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group controlId={`formGridRelationship-${index}`}>
                      <Form.Label>
                        Relationship <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        value={contact.relation}
                        onChange={(e) =>
                          handleContactChange(index, "relation", e.target.value)
                        }
                        disabled
                      >
                        <option value="">Select Option</option>
                        <option value="Father">Father</option>
                        <option value="Mother">Mother</option>
                        <option value="Brother">Brother</option>
                        <option value="Sister">Sister</option>
                        <option value="Cousin">Cousin</option>
                        <option value="Uncle">Uncle</option>
                        <option value="Friend">Friend</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group controlId={`formGridPrimaryNumber-${index}`}>
                      <Form.Label>
                        Primary Mobile Number
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Mobile Number"
                        value={contact.number}
                        onChange={(e) =>
                          handleContactChange(index, "number", e.target.value)
                        }
                        maxLength={10}
                        disabled
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group controlId={`formGridAlternateNumber-${index}`}>
                      <Form.Label>Alternate Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Mobile Number"
                        value={contact.alternateNumber}
                        onChange={(e) =>
                          handleContactChange(
                            index,
                            "alternateNumber",
                            e.target.value
                          )
                        }
                        maxLength={10}
                        disabled
                      />
                    </Form.Group>
                  </Col>

                  {/* {index > 0 && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        style={{ top: 0, right: 15 }}
                        onClick={() => handleRemoveContact(index)}
                      >
                        Remove
                      </button>
                    )} */}
                </div>
              ))}

              {!props?.isAddUser && (
                <Row className="g-3">
                  <h5 className="txt-primary">System Details</h5>
                  {/* <h5 className="txt-primary">User Activity Analytics</h5> */}
                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Last Logged On</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Created Date"
                        disabled
                        value={extractDateFromISO(userLogData?.created_at)}
                        // onChange={(e) => setUserName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Average Usage</Form.Label>
                      <Form.Control type="text" placeholder="--" disabled />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Created On</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Date"
                        disabled
                        value={extractDateFromISO(props?.data?.create_on)}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Last Modified On</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Date"
                        disabled
                        value={extractDateFromISO(
                          props?.data?.last_modified_on
                        )}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Deactivated On</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Date"
                        disabled
                        value={extractDateFromISO(props?.data?.deactivated_on)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              {/* {!props?.isAddUser && (
                <Row className="g-3">
                  <h5 className="txt-primary">Login Details</h5>
                  <Col md={3}>
                    <Form.GroupDate of Birth 
                      controlId="formGridUserName"
                      className="input-group-solid"
                    >
                      <Form.Label>Login ID</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type={showEmail ? "text" : "password"}
                          placeholder=""
                          value={userEmail}
                          onChange={(e) => setUserEmail(e.target.value)}
                          style={{ paddingRight: "35px" }}
                        />

                        <button
                          type="button"
                          // onClick={toggleEmailVisibility}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            padding: "4px",
                          }}
                        >
                          {showEmail ? (
                            <span>
                              <i className="icon-eye"></i>
                            </span>
                          ) : (
                            <span>
                              <i className="fa fa-eye-slash"></i>
                            </span>
                          )}
                        </button>
                      </div>
                    </Form.GroupDate>
                  </Col>

                  <Col md={3}>
                    <Form.Group
                      controlId="formGridPassword"
                      className="input-group-solid"
                    >
                      <Form.Label>Password</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder=""
                          value={passDeclare}
                          style={{ paddingRight: "35px" }}
                        />
                        <button
                          type="button"
                          // onClick={togglePasswordVisibility}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            padding: "4px",
                          }}
                        >
                          {showPassword ? (
                            <span>
                              <i className="icon-eye"></i>
                            </span>
                          ) : (
                            <span>
                              <i className="fa fa-eye-slash"></i>
                            </span>
                          )}
                        </button>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              )} */}
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DetailInfoAdmin;
